import { Fragment, useState } from 'react';
import { Box, Button, Popover } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const CustomPopover = ({
  label = 'Actions',
  icon = true,
  children,
  buttonProps = {},
  popoverProps = {},
  sx = {},
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Fragment>
      <Button
        onClick={handleClick}
        endIcon={icon ? (open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />) : null}
        {...buttonProps}
      >
        {label}
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            sx: { p: 2, ...sx },
          },
        }}
        {...popoverProps}
      >
        <Box display="flex" flexDirection="column" gap={1}>
          {typeof children === 'function' ? children({ close: handleClose }) : children}
        </Box>
      </Popover>
    </Fragment>
  );
};

export default CustomPopover;